module.exports = require("autolinker");